import Repository from './Repository';

const resource = '/order';

export default class OrderRepository {
  static checkOrder(state) {
    return Repository.post(`${resource}/check-order`, { state });
  }

  static setOrder(state) {
    return Repository.post(`${resource}/set`, { state });
  }

  static getOrderData(orderId) {
    return Repository.get(`${resource}/get-order-data?orderId=${orderId}`);
  }

  static editOrder(orderId, state) {
    return Repository.post(`${resource}/edit-order?orderId=${orderId}`, { state });
  }
}
